<template>
  <div class="jobs-list" v-loading="loader">
    <el-input placeholder="Поиск ..." v-model="search" class="input-search">
      <el-button slot="append" icon="el-icon-search"></el-button>
    </el-input>
    <el-checkbox style="margin-top: 10px" v-model="project.directive" @change="saveDirective">Директивный план</el-checkbox>
    <div class="jobs-ul">
      <div
        class="jobs-li" v-for="(plan, index) in filteredList" :key="index"
      >
        <div class="name">
          <el-checkbox v-model="plan.enabled" @change="update(plan)"></el-checkbox>
          <span style="margin-left: 10px">{{ plan.name || plan.label }}</span>
        </div>
        <router-link :to="`/dashboard/plan/${plan.id}/edit`">
          <i class="fa fa-edit"></i>
        </router-link>
      </div>
    </div>
    <router-link :to="`/dashboard/plan/create/`" class="add-job">
      <el-button>+ Добавить</el-button>
    </router-link>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import draggable from 'vuedraggable';
import work_units from '../../../data/work_units';
import {getUnits} from '../../../firestore/units';
import {getPlans} from "../../../firestore/plan";
import dayjs from "dayjs";

export default {
  name: 'PlanIndex',
  components: {draggable},

  data() {
    return {
      loader: false,
      search: '',
      plans: [],
      form: {
        is_directive: false
      },
      project: {
        directive: false
      }
    };
  },

  mounted() {
    this.fetchJobs();
    this.project.directive = !this.$store.state.project.directiveOff
  },

  methods: {
    async fetchJobs() {
      this.loader = true;

      try {
        this.plans = await getPlans(this.$store.state.project.id);
      } catch (e) {
        console.log(e, 'e');
      }

      this.loader = false;
    },
    saveDirective() {
      this.$store.dispatch('setProject', {
        ...this.$store.state.project,
        directiveOff: !this.project.directive
      });

      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .update({
          ...this.$store.state.project,
          directiveOff: !this.project.directive
        })

    },
    update(plan) {
        const docRef = myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(plan.id)
          .update({enabled: plan.enabled});

        if(plan.id === this.$store.state.project.plan.id) {
          localStorage.setItem('plan', JSON.stringify(plan))

          this.$store.dispatch('setProject', {
            ...this.$store.state.project,
            plan: {
              ...plan
            }
          });
        }
    },
  },

  computed: {
    filteredList() {
      return this.plans.filter(plan => {
        if (!plan.name) return true
        return String(plan.name).toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
};
</script>

<style scoped lang="scss">
.jobs-list {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 22px auto;
}

.input-search {
  margin-top: 12px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .jobs-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;

    color: #000;
    text-decoration: none !important;

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.notify {
  background: #f0f0f0;
  color: #888;
  font-size: 13px;
  padding: 8px 4px;
  border-radius: 4px;
}

.add-job {
  > > > button {
    width: 100%;
    margin-top: 12px;
  }
}

.fa-edit {
  color: #000;
}

.fa-trash {
  margin-right: 15px;
}

.name {
  display: flex;
  align-items: center;

  i {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Plan/Index.vue